import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';
import TitDer from '../../../components/funcionales/titder';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// import SeguroPermite from '../../../components/funcionales/seguropermite'
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

const ListaVer = ({styles, handleChange}) => {
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="miLista1" id="miLista1" onChange={(ev)=>handleChange(ev)}>
        {/* <option>Seleccionar...</option> */}
        <option>Todo</option>
        <option>Pendiente</option>
        <option>Reportado</option>
        <option>No ejecutado</option>
      </select>
    </div>
  )
};

const DetalleEmpNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
    )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista3" onChange={(ev)=>handleChange(ev)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNuminfNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.ruta}</option>
    )
};

const ListaNuminf = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNuminfNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="ruta" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

//Lista de mecanismos del informe
const DetallePl = ({elemento, handleClickidLista}) => {
  let colorCelda='white', colorNoEjec='white'
  if(elemento.alimSistema && elemento.alimSistema==='S'){
    colorCelda = 'green'
    colorNoEjec='green'
    if(elemento.realizado==='N'){
      colorNoEjec='red'
    }
  }
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: colorNoEjec, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProg.substr(0, 10)}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.realizado==='S'?elemento.fechaReal.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuarioReal?elemento.nombreUsuarioReal:''}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaUlt.subst?elemento.fechaUlt.substr(0, 10):''}</td>
    </tr>
  )
};

const ListaPl = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos del informe

// const DetallePlDet = ({elemento, handleClickidLista, idLista}) => {
//   let urlSlcm = 'https://montserratslcm.com/api/imgorden/' 
//   let colorCelda='white'
//   if(elemento.alimSistema && elemento.alimSistema==='S'){
//     colorCelda = 'green'
//   }
//   return(
//     <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.numeroOrden}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.descrFrecuencia}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.descrLubricante}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.realizado}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.numeroInflab}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.mecInflab}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.fechaReal?elemento.fechaReal.substr(0, 10):''}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.horaReal?elemento.horaReal:0}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.minutosReal}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.cantidadReal}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.abrevUnidad}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.acumReal}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.observacionesReal}</td>

//     </tr>

//   )
// };

// const ListaPlDet = ({list, handleClickidLista, idLista}) => {
//   const nivel1Detalle = list.map((elemento, i) => <DetallePlDet elemento={elemento} handleClickidLista={handleClickidLista} 
//   key={i} idLista={idLista}/>);
//   return(
//     <tbody className=''>
//       {nivel1Detalle}
//     </tbody>
//   )
// };

class ProgRepProg2 extends React.Component {
  state={listDocum: [], listNum: [], list: [], argsDocum: {ruta: 0, descrEmpresa: 'xxx', miLista1: 'Todo'}, checked: true, confirmaAct: false,
         argsBuscProg: {}, open: false, errors: [], procBtn: 0, permiteBtn1: true, permiteBtn2: true, idLista: {}, 
      argsQuery: `{$project: {ruta: {"$toString": "$ruta"}, 
      descrEmpresa: '$descrEmpresa'}},
      {$group: {_id: {ruta: '$ruta', descrEmpresa: '$descrEmpresa'}}}, 
      {$project: {_id:{$concat: ["$_id.ruta", "$_id.descrEmpresa"]}, ruta: '$_id.ruta', descrEmpresa: '$_id.descrEmpresa'}},
      {$sort: {ruta: -1}}`
    }

  // handleClickidLista = async (ev, idLista)=>{
  //   ev.preventDefault()
  //     this.setState({idLista: idLista})
  // }

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev) => {
    const updState = (listDocum) => {
      this.setState({listDocum, errors: []})
    };
    let listNum = [], list = []
    let argsBuscar="'estadoOrden': 'Abierto'"

    if(this.props.argsBuscProg.descrPlanta){
      argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
    }
    if(this.props.argsBuscProg.descrSeccion){
      argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
    }
    if(this.props.argsBuscProg.descrEquipo){
      argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
    }

    if(ev.target.name==="descrEmpresa"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      argsDocum["ruta"] = 'Seleccionar ruta...'
      let empre=ev.target.value
      if(empre!=='Seleccionar Empresa...'){
        let argsBuscarNum = {tipoqry: `[{$match: {'estadoOrden': 'Abierto', 'descrEmpresa': '${empre}'}}, ${this.state.argsQuery}]`}
        let {data} = await this.props.allOrdenRtes.refetch(argsBuscarNum)
        listNum = await data.allOrdenRtes
      }

      this.setState({argsDocum, listNum, list});
    }else{
      if(ev.target.name==="ruta"){
        const argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.value
        let numRuta=ev.target.value
        
        if(numRuta!=='Seleccionar ruta...'){
          let ver=argsDocum["miLista1"]
          if(ver==='Todo'){
            argsBuscar += `, 'ruta': ${numRuta}`
          }else{
            if(ver==='Pendiente'){
              argsBuscar += `, 'alimSistema': 'N', 'ruta': ${numRuta}`
            }else{
              if(ver==='Reportado'){
                argsBuscar += `, 'alimSistema': 'S', 'ruta': ${numRuta}`
              }else{
                if(ver==='No ejecutado'){
                  argsBuscar += `, 'alimSistema': 'S', 'realizado': 'N', 'ruta': ${numRuta}`
                }
              }
            }
          }
          let argsBuscarOrden = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {fechaProg: 1}}]`}
          let {data} = await this.props.allOrdenRtes2.refetch(argsBuscarOrden)
          list = await data.allOrdenRtes
        }
        this.setState({argsDocum, list});
      }else{
    //Cargar archivo
        if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
          let checkTieneEncab = document.getElementById("checkTieneEncab").checked
          let fileInput = document.getElementById("csv")
          // console.log(fileInput.files.length)
          if(fileInput.files.length>0){
            document.body.style.cursor = 'wait'

            let archcsv = ""
            let reader = new FileReader();
            reader.onload = function () {
              archcsv = reader.result

              //asignar los datos del archivo a archivo
              let archivo = archcsv.toString()
              let lines = archivo.split(/\n/)
              let numDoc = 0, linea = 0, listDocum = []
              lines.forEach(line => {
                let linesReg = line.split(/\n/)
                if(linesReg.length>1){
                  console.log(line)
                }
                // console.log(listDocum)
                if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
                  linea += 1
                  // console.log(linea)
                  //crear array de campos para cada linea
                  // console.log(line)
                  let campos = line.split(";")
// console.log(campos[0])
                  let ruta = parseInt(campos[0], 10)
// console.log(ruta)
                  let numeroOrden = parseInt(campos[1], 10)
                  let ordenSAP = campos[2]?campos[2].replace(/^\s+|\s+$/g, ''):''
                  let descrFrecuencia = campos[3]
                  let fechaProg = ''
                  let campoMes = ''
                  let campoDia= ''
                  if(campos[5]!==null && campos[5]!=='' && campos[6]!==null && campos[6]!=='' && campos[7]!==null && campos[7]!==''){
                    if(campos[5]==='DI' && campos[6]==='AR' && campos[7]==='IO'){
                    }else{
                      let mes = parseInt(campos[6], 10)
                      if(mes < 10){ 
                        campoMes='0' + mes
                      }else{
                        campoMes = mes
                      }
                      let dia = parseInt(campos[7], 10)
                      if(dia < 10){ 
                        campoDia='0' + dia
                      }else{
                        campoDia = dia
                      }
                      fechaProg = campos[5] + '-' + campoMes + '-' + campoDia                
                    }
                  }
                  let descrPlanta = campos[8]
                  let descrSeccion = campos[9]
                  let descrEquipo = campos[10]
                  let descrComponente = campos[11]
                  let descrMecanismo = campos[12]
                  let descrMetodo = campos[13]
                  let descrTarea = campos[14]
                  let modoTarea = campos[15]
                  let requiereSISO = campos[16]
                  let descrLubricante = campos[17]
                  let cantidad = 0
                  if(campos[18]==null || campos[18]==''){
                  }else{
                    cantidad = campos[18].replace(/\./g,'');
                    cantidad = cantidad.replace(/\,/g,'.');
                    cantidad = parseFloat(cantidad)
                  }                
                  let abrevUnidad = campos[19]
                  let puntosLub = campos[20]
                  let minutos = campos[21]
                  let alimSistema = 'S'
                  let realizado = campos[23]
                  let fechaReal = ''
                  let cedulaReal = ''   
                  let cantidadReal = 0  
                  let minutosReal = 0 
                  let horaReal = 0      

                  if(realizado==='S'){
                    campoMes = ''
                    campoDia= ''
                    if(campos[24]!==null && campos[24]!=='' && campos[25]!==null && campos[25]!=='' && campos[26]!==null && campos[26]!==''){
                      let mes = parseInt(campos[25], 10)
                      if(mes < 10){ 
                        campoMes='0' + mes
                      }else{
                        campoMes = mes
                      }
                      let dia = parseInt(campos[26], 10)
                      if(dia < 10){ 
                        campoDia='0' + dia
                      }else{
                        campoDia = dia
                      }
                      fechaReal = campos[24] + '-' + campoMes + '-' + campoDia
                    }              
                    if(campos[27]==null || campos[27]==''){
                    }else{
                      horaReal = parseInt(campos[27])
                    }  
                    if(campos[28]==null || campos[28]==''){
                    }else{
                      cedulaReal = campos[28]
                    }          
                    // console.log(campos[28])                 
                    // cantidadReal = campos[23]?campos[23].replace(/\./g,''):0
                    if(campos[29]==null || campos[29]==''){
                    }else{
                      cantidadReal = campos[29].replace(/\./g,'');
                      cantidadReal = cantidadReal.replace(/\,/g,'.');
                      cantidadReal = parseFloat(cantidadReal)
                    }   
                    minutosReal = parseInt(campos[30], 10)
                  }
                  let acumReal = campos[30]?parseInt(campos[31], 10):0
                  let tempAntesLub = campos[31]?parseInt(campos[32], 10):0
                  let tempDespuesLub = campos[32]?parseInt(campos[33], 10):0
                  let ultraAntesLub = campos[33]?parseInt(campos[34], 10):0
                  let ultraDespuesLub = campos[34]?parseInt(campos[35], 10):0
                  let vibraAntesLub = campos[35]?parseInt(campos[36], 10):0
                  let vibraDespuesLub = campos[36]?parseInt(campos[37], 10):0
                  let observacionesReal=''            
                  if(campos[39]==null || campos[39]==''){
                  }else{
                    // observacionesReal = campos[39].replace(/^\s+|\s+$/g, '')
                    observacionesReal = campos[39].replace(/(\r\n|\n|\r)/gm, '')
                  }                                  
                  
                  let fallaLub = campos[42]
                  if(fallaLub==='S' || fallaLub==="s" || fallaLub==='Si' || fallaLub==='si' || fallaLub==='"S"' || fallaLub==='"s"'){
                    fallaLub='S'
                  }else{
                    fallaLub='N'
                  }
                  let tiempoFalla = parseInt(campos[43])
                  let costoFalla = parseInt(campos[44])
    //Separador de decimales => .
//     if(ruta=NaN || numeroOrden===0){
// console.log(numDoc, linea, campos)
//     }
// console.log(ruta)
// console.log(listDocum)
                    if(ruta!==NaN && ruta!=='' && numeroOrden!==0){
                      listDocum.push({ruta, numeroOrden, ordenSAP, descrFrecuencia, fechaProg, descrPlanta, descrSeccion, descrEquipo, 
                        descrComponente, descrMecanismo, descrMetodo, descrTarea, modoTarea, requiereSISO, descrLubricante, cantidad,
                        abrevUnidad, puntosLub, minutos, alimSistema, realizado, fechaReal, horaReal, cedulaReal, cantidadReal, minutosReal,
                        acumReal, tempAntesLub, tempDespuesLub, ultraAntesLub, ultraDespuesLub, vibraAntesLub, vibraDespuesLub, 
                        observacionesReal, fallaLub, tiempoFalla, costoFalla})
                    }
                  }
                numDoc += 1
                // console.log(numDoc)
              })
              console.log(listDocum)

              listDocum = _.orderBy(listDocum, ['numeroOrden'], ['asc'])
              // console.log(listDocum)
              updState(listDocum)
            };
            // start reading the file. When it is done, calls the onload event defined above.
            reader.readAsBinaryString(fileInput.files[0]);
            this.setState({checked: checkTieneEncab})
            document.body.style.cursor = 'default'
          }else{
            this.setState({listDocum: [], errors: []})
          }
        }else{
          if(ev.target.name==="miLista1"){
    
            const argsDocum = this.state.argsDocum
            argsDocum[ev.target.name] = ev.target.value
            let ver=ev.target.value
            if(argsDocum["descrEmpresa"]!=='Seleccionar Empresa...' && argsDocum["ruta"]!=='Seleccionar ruta...'){
              if(ver==='Todo'){
                argsBuscar += `, 'ruta': ${argsDocum["ruta"]}`
              }else{
                if(ver==='Pendiente'){
                  argsBuscar += `, 'alimSistema': 'N', 'ruta': ${argsDocum["ruta"]}`
                }else{
                  if(ver==='Reportado'){
                    argsBuscar += `, 'alimSistema': 'S', 'ruta': ${argsDocum["ruta"]}`
                  }else{
                    if(ver==='No ejecutado'){
                      argsBuscar += `, 'alimSistema': 'S', 'realizado': 'N', 'ruta': ${argsDocum["ruta"]}`
                    }
                  }
                }
              }
              let argsBuscarOrden = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {fechaProg: 1}}]`}
              let {data} = await this.props.allOrdenRtes2.refetch(argsBuscarOrden)
              list = await data.allOrdenRtes
            }
            this.setState({argsDocum, list});
          }
        }
      }
    }
  }

  handleSubmit = async (ev, listDocum, list)=>{
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha

    document.body.style.cursor = 'wait'
console.log(listDocum)
    let errors = []
    let allUsuarios = this.props.allUsuarios.allUsuarios
    let allLubricante = this.props.allLubricante.allLubricante

    if(listDocum.length===0){
      errors.push({path: "Cargue", message: "No hay información para cargar"});
    }else{
      console.log(listDocum[0])
      const numeroOrden = list.findIndex( ordens => parseInt(ordens.numeroOrden, 10) === parseInt(listDocum[0].numeroOrden, 10) && parseInt(ordens.ruta, 10) === parseInt(listDocum[0].ruta, 10));
      if(numeroOrden===-1){
        errors.push({path: "Cargue", message: `El archivo a cargar no corresponde a la ruta programada ${this.state.argsDocum.ruta}`});
      }
    }
    this.setState({errors})
    if(errors.length===0){
//PROCESO CARGAR INFORME
      for(let i=0; i<listDocum.length; i++){
        if(i>5053){
console.log(listDocum[i])
        }
        let realizado = listDocum[i].realizado
        let cedulaReal = listDocum[i].cedulaReal
        let fechaReal = listDocum[i].fechaReal
        let horaReal = listDocum[i].horaReal?listDocum[i].horaReal:0
        let cantidadReal = listDocum[i].cantidadReal
        let minutosReal = listDocum[i].minutosReal
        let descrLubricante = listDocum[i].descrLubricante

        if(listDocum[i].ruta===NaN || !listDocum[i].ruta || listDocum[i].ruta===''){
        }else{
          if(!realizado){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de Realizado`});
          }else{
            if(realizado!=='N' && realizado!=='S'){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de Realizado No es valido (${realizado})`});
            }else{
              if(realizado==='S' && (!fechaReal || !descrLubricante || cantidadReal===null || cantidadReal==='' || minutosReal===null || minutosReal==='' ||  cedulaReal===null || cedulaReal==='')){
                console.log(fechaReal, cantidadReal, minutosReal, cedulaReal)
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Datos de ejecución incompletos`});
              }else{
                if(realizado==='S' && cedulaReal){
                  let indexOpe = allUsuarios.findIndex( operario => operario.cedula===cedulaReal )
                  if(indexOpe===-1){
                    errors.push({path: "Cargue", message: `Línea: ${i + 1} El operario con cedula ${cedulaReal} no ha sido creado`});
                  } 
                }   
                if(realizado==='S' && descrLubricante){
                  let indexLub = allLubricante.findIndex( lubricante => lubricante.descrLubricante===descrLubricante )
                  if(indexLub===-1){
                    errors.push({path: "Cargue", message: `Línea: ${i + 1} El lubricante ${descrLubricante} no ha sido creado`});
                  } 
                }               
              }          
            }
          }
        }
      }
    }
    document.body.style.cursor = 'default'
    
    if(errors.length===0){
      document.body.style.cursor = 'wait'

      let updColecc = []
      let argsUpd = {}
      for(let i=0; i<listDocum.length; i++){
        if(listDocum[i].ruta===NaN || !listDocum[i].ruta || listDocum[i].ruta===''){
        }else{
          let nombreUsuarioReal = ''
          let indexLub = -1
          let descrLubricante = ''
          let descrFabricante = ''
          let claseLub = ''
          if(listDocum[i].realizado==='S'){
            let indexOpe = allUsuarios.findIndex( operario => operario.cedula===listDocum[i].cedulaReal )
            nombreUsuarioReal = allUsuarios[indexOpe].nombreUsuario
            indexLub = allLubricante.findIndex( lubricante => lubricante.descrLubricante===listDocum[i].descrLubricante )
            descrLubricante = allLubricante[indexLub].descrLubricante
            descrFabricante = allLubricante[indexLub].descrFabricante
            claseLub = allLubricante[indexLub].claseLub
          }else{
            indexLub = list.findIndex( ordens => parseInt(ordens.numeroOrden, 10) === parseInt(listDocum[i].numeroOrden, 10) );
            descrLubricante = list[indexLub].descrLubricante
            descrFabricante = list[indexLub].descrFabricante
            claseLub = list[indexLub].claseLub
          }
          indexLub = list.findIndex( ordens => parseInt(ordens.numeroOrden, 10) === parseInt(listDocum[i].numeroOrden, 10) );
          let imgAntes = list[indexLub].imgAntes?list[indexLub].imgAntes:''
          let imgDespues = list[indexLub].imgDespues?list[indexLub].imgDespues:''
          
          argsUpd['ruta'] = listDocum[i].ruta
          argsUpd['numeroOrden'] = listDocum[i].numeroOrden
          argsUpd['ordenSAP'] = listDocum[i].ordenSAP?listDocum[i].ordenSAP:''
          argsUpd['tipoAct'] = 'EditarEjec'
          argsUpd['fechaUpd'] = fechaHoraHoy
          argsUpd['usuarioUpd'] = localStorage.getItem('userLogin')
          argsUpd['numeroOrden'] = listDocum[i].numeroOrden
          argsUpd['realizado'] = listDocum[i].realizado
          argsUpd['observacionesReal'] = listDocum[i].observacionesReal?listDocum[i].observacionesReal:''
          argsUpd['tempAntesLub'] = listDocum[i].tempAntesLub?listDocum[i].tempAntesLub:0
          argsUpd['tempDespuesLub'] = listDocum[i].tempDespuesLub?listDocum[i].tempDespuesLub:0
          argsUpd['ultraAntesLub'] = listDocum[i].ultraAntesLub?listDocum[i].ultraAntesLub:0
          argsUpd['ultraDespuesLub'] = listDocum[i].ultraDespuesLub?listDocum[i].ultraDespuesLub:0
          argsUpd['vibraAntesLub'] = listDocum[i].vibraAntesLub?listDocum[i].vibraAntesLub:0
          argsUpd['vibraDespuesLub'] = listDocum[i].vibraDespuesLub?listDocum[i].vibraDespuesLub:0
          argsUpd['imgAntes'] = imgAntes
          argsUpd['imgDespues'] = imgDespues
          argsUpd['fallaLub'] = listDocum[i].fallaLub?listDocum[i].fallaLub:'N'
          argsUpd['tiempoFalla'] = listDocum[i].tiempoFalla?listDocum[i].tiempoFalla:0
          argsUpd['costoFalla'] = listDocum[i].costoFalla?listDocum[i].costoFalla:0
          argsUpd['alimSistema'] = 'S'
          if(listDocum[i].realizado==='S'){
            argsUpd['fechaReal'] = listDocum[i].fechaReal
            argsUpd['horaReal'] = listDocum[i].horaReal?listDocum[i].horaReal:0
            argsUpd['cedulaReal'] = listDocum[i].cedulaReal
            argsUpd['minutosReal'] = listDocum[i].minutosReal
            argsUpd['cantidadReal'] = listDocum[i].cantidadReal 
            argsUpd['nombreUsuarioReal'] = nombreUsuarioReal
            argsUpd['acumReal'] = listDocum[i].acumReal?listDocum[i].acumReal:0
            argsUpd['descrLubricante'] = descrLubricante
            argsUpd['descrFabricante'] = descrFabricante
            argsUpd['claseLub'] = claseLub
          }else{
            argsUpd['fechaReal'] = listDocum[i].fechaProg
            argsUpd['horaReal'] = 0
            argsUpd['cedulaReal'] = listDocum[i].cedula
            argsUpd['minutosReal'] = 0
            argsUpd['cantidadReal'] = 0 
            argsUpd['nombreUsuarioReal'] = listDocum[i].nombreUsuario
            argsUpd['acumReal'] = listDocum[i].acumReal?listDocum[i].acumReal:0
            argsUpd['descrLubricante'] = descrLubricante
            argsUpd['descrFabricante'] = descrFabricante
            argsUpd['claseLub'] = claseLub
          }
  console.log(argsUpd)


          const response = await this.props.editOrden({
            variables: argsUpd
          });
          const {errors, success} = response.data.editOrden;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
          }
        }
      }
      
      const argsDocum=this.state.argsDocum
      let ruta=argsDocum.ruta
      await this.props.allOrdenRtes.refetch()
      ruta=this.props.allOrdenRtes.allOrdenRtes.length>0?this.props.allOrdenRtes.allOrdenRtes[0].ruta:0
      argsDocum['ruta'] = ruta
      this.setState({argsDocum});  

      let argsBuscar=""
      argsBuscar += `'ruta': ${ruta}`
      let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
      this.props.allOrdenRtes2.refetch(argsBuscarIl)      

      if(listDocum.length>0){
        alert("!! Carga exitosa !!")
      }
      document.body.style.cursor = 'default'

    }
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})

  }

  handleCerrar = async (ev, list)=>{
    if(list.length>0){
      // await list.forEach(async (elemento, i) => {
      for(let i=0; i<list.length; i++){
        // let elemento = list[i]
        document.body.style.cursor = 'wait'

        let argsUpd = {}
        let updColeccEq = []
        let addColeccPl = []
        let argsEqu = {}
        let updColeccOrden = []
        let argsOrden = {}
        let argsProg = {}
        let argsPl = {}
        let updColeccProg = [], updColeccProg1 = []
        let cantidadFre = 0

        let indexFre=-1
        let allFrecuencia = this.props.allFrecuencia.allFrecuencia
        let fechaR = moment(list[i].fechaReal).format('YYYY-MM-DD')
        let fechaPr = moment(list[i].fechaReal).format('YYYY-MM-DD')
        let acumProxNuevo=0
        let numUpd = 2

        if(list[i].realizado==='S' && list[i].descrFrecuencia!=='Hallazgo'){
          console.log(list[i].descrFrecuencia)
          if(list[i].descrFrecuencia==='Predictiva'){
            indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[i].descrFrecuenciaPre )
          }else{
            indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[i].descrFrecuencia )
          }
          cantidadFre = allFrecuencia[indexFre].cantidad
          
          if(list[i].tipoFrecuencia==='Calendario'){
            console.log(fechaR, cantidadFre)
            fechaPr = moment(fechaR).add(cantidadFre, 'd').format('YYYY-MM-DD')
            console.log(fechaPr)
          }else{
            acumProxNuevo=list[i].acumReal + cantidadFre
          }
        }

        if(list[i].tipoFrecuencia!=='Calendario' && list[i].acumReal!==null && list[i].acumReal!=='' && list[i].acumReal>0){
// ACTUALIZAR COLLECCION equipos
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha

          argsEqu['descrEmpresa'] = list[i].descrEmpresa
          argsEqu['descrPlanta'] = list[i].descrPlanta
          argsEqu['descrSeccion'] = list[i].descrSeccion
          argsEqu['descrEquipo'] = list[i].descrEquipo
          argsEqu['fechaAcum'] = fechaHoraHoy
          argsEqu['usuarioAcum'] = localStorage.getItem('userLogin')
          argsEqu['acumulado'] = list[i].acumReal  
          argsEqu['tipoAct'] = "EditarAcumProg"

          updColeccEq.push(argsEqu)
          argsEqu = {}
          numUpd += 1

// FIN ACTUALIZAR COLLECCION equipos
        }

// ACTUALIZAR SUBDOCUMENTO programacion
        argsProg['descrMetodo'] = list[i].descrMetodo
        argsProg['descrTarea'] = list[i].descrTarea
        if(list[i].realizado==='S'){
          argsProg['ultObservacion'] = list[i].observacionesReal
          if(list[i].tipoFrecuencia==='Calendario'){
            argsProg['fechaUlt'] = list[i].fechaReal
            argsProg['fechaProx'] = fechaPr   
            argsProg['acumUlt'] = 0
            argsProg['acumProx'] = 0   
          }else{
            argsProg['fechaUlt'] = list[i].fechaReal
            argsProg['fechaProx'] = ''      
            argsProg['acumUlt'] = list[i].acumReal
            argsProg['acumProx'] = parseInt(acumProxNuevo)             
          }
        }else{
          argsProg['fechaUlt'] = 'N'
          argsProg['ultObservacion'] = ''
          argsProg['fechaProx'] = list[i].fechaProg      
          argsProg['acumUlt'] = list[i].acumUlt
          argsProg['acumProx'] = parseInt(list[i].acumProx)                    
        }
        argsProg['enRuta'] = 'N'
        console.log(argsProg)
        updColeccProg.push(argsProg)
        argsProg = {}

        argsPl['descrEmpresa'] = list[i].descrEmpresa
        argsPl['descrPlanta'] = list[i].descrPlanta
        argsPl['descrSeccion'] = list[i].descrSeccion
        argsPl['descrEquipo'] = list[i].descrEquipo
        argsPl['descrComponente'] = list[i].descrComponente
        argsPl['descrMecanismo'] = list[i].descrMecanismo
        argsPl['descrMetodo'] = list[i].descrMetodo
        argsPl['descrTarea'] = list[i].descrTarea

        argsPl['programacion'] = updColeccProg
        argsPl['tipoAct'] = "CerrarProgramacionRuta"
        addColeccPl.push(argsPl)

        // for(let iii=0; iii<addColeccPl.length; iii++){
          // updColeccProg.push(addColeccPl[0])
        // }
        updColeccProg1.push({planta: addColeccPl})
// FIN ACTUALIZAR SUBDOCUMENTO programacion

// ACTUALIZAR COLECCION ordens
        argsOrden['ruta'] = list[i].ruta
        argsOrden['numeroOrden'] = list[i].numeroOrden
        argsOrden['estadoOrden'] = 'Cerrado'
        argsOrden['tipoAct'] = 'EditarEstado'

        updColeccOrden.push(argsOrden)
        argsOrden = {}
// FIN ACTUALIZAR COLECCION ordens
        // console.log(numUpd)
        let numDocCRUD = 0
        let totDocCRUD = numUpd
        let argsCrud = []
        let crudColecc = []

        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editOrden)
        }

        if(totDocCRUD === 3){
            argsCrud[numDocCRUD] = updColeccEq[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion
      
            numDocCRUD += 1
        }

        argsCrud[numDocCRUD] = updColeccProg1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editPlantaEstructura

        numDocCRUD += 1
  
        argsCrud[numDocCRUD] = updColeccOrden[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editOrden
console.log(argsCrud)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)

      }
      const argsDocum=this.state.argsDocum
      let ruta=argsDocum.ruta
      await this.props.allOrdenRtes.refetch()
      ruta=this.props.allOrdenRtes.allOrdenRtes.length>0?this.props.allOrdenRtes.allOrdenRtes[0].ruta:0
      argsDocum['ruta'] = ruta
      this.setState({argsDocum});  

      let argsBuscar=""
      argsBuscar += `'ruta': ${ruta}`
      let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
      this.props.allOrdenRtes2.refetch(argsBuscarIl)
      document.body.style.cursor = 'default'

      if(list.length>0){
        alert("!! Ruta cerrada !!")
      }

    }
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }

  handleCopiaInf = async (ev, list)=>{
    if(list.length>0){
//Archivo Excel
      let xlsString = []
      let listRtes = list
      let descrEmpresa = ''
      let xlsString1 = []
      xlsString1 = ['Ruta', 'OT', 'OT SAP', 'Frecuencia', 'Fecha última ejec.', 'Año', 'Mes', 'Día', 'Planta', 'Sección', 'Equipo', 'Componente',
        'Mecanismo', 'Método', 'Tarea', 'Modo ejec tarea', 'Requiere SISO', 'Lubricante', 'Cantidad', 'Und', 'Puntos', 'Minutos', 'Alim. sistema', 'Realizado?', 'Año real', 'Mes real', 'Día real', 'Hora real (0-23)',
        'Operario real', 'Cant. real', 'Min. real', 'Acum. Horas/Km', 'Temperatura antes lub.', 'Temperatura despues lub.', 
        'Ultrasonido antes lub.', 'Ultrasonido despues lub.', 'Vibraciones antes lub.', 'Vibraciones despues lub.', 
        'Observación anterior', 'Observación actual', 'Rep. Lab.', 'Inf. Lab.', 'Hallazgo - Falla por lubricación (S/N)', 'Hallazgo - Duración falla (Horas)', 'Hallazgo - Costo por falla ($)']
      xlsString.push(xlsString1)

      let campoAgno = ''
      for(let i=0; i<listRtes.length; i++){
        campoAgno = ''
        let campoMes = ''
        let campoDia= ''
        // if(listRtes[i].descrFrecuencia!=='Diario'){
          if(listRtes[i].fechaProg!==null && listRtes[i].fechaProg!==''){
            campoAgno = listRtes[i].fechaProg.substring(0, 4)
            campoMes = listRtes[i].fechaProg.substring(5, 7)
            campoDia = listRtes[i].fechaProg.substring(8, 10)
          }    
        // }else{
        //   campoAgno = 'DI'
        //   campoMes = 'AR'
        //   campoDia= 'IO'
        // }
        let campoAgnoR = ''
        let campoMesR = ''
        let campoDiaR= ''
        if(listRtes[i].fechaReal!==null && listRtes[i].fechaReal!==''){
          campoAgnoR = listRtes[i].fechaReal.substring(0, 4)
          campoMesR = listRtes[i].fechaReal.substring(5, 7)
          campoDiaR = listRtes[i].fechaReal.substring(8, 10)
        }    
        let fechaUlt=''
        if(listRtes[i].fechaUlt!==null && listRtes[i].fechaUlt!==''){
          fechaUlt = listRtes[i].fechaUlt.substr(0, 10)
        }

        xlsString1 = [listRtes[i].ruta, listRtes[i].numeroOrden, listRtes[i].ordenSAP?listRtes[i].ordenSAP:'', 
        listRtes[i].descrFrecuencia, fechaUlt, campoAgno, campoMes, campoDia, listRtes[i].descrPlanta,
        listRtes[i].descrSeccion, listRtes[i].descrEquipo, listRtes[i].descrComponente, listRtes[i].descrMecanismo, 
        listRtes[i].descrMetodo, listRtes[i].descrTarea, listRtes[i].modoTarea, listRtes[i].requiereSISO, listRtes[i].descrLubricante, listRtes[i].cantidad, 
        listRtes[i].abrevUnidad, listRtes[i].puntos, listRtes[i].minutos, listRtes[i].alimSistema, listRtes[i].realizado, campoAgnoR, campoMesR, campoDiaR, listRtes[i].horaReal, 
        listRtes[i].cedulaReal, listRtes[i].cantidadReal, listRtes[i].minutosReal, listRtes[i].acumReal, 
        listRtes[i].tempAntesLub, listRtes[i].tempDespuesLub, listRtes[i].ultraAntesLub, listRtes[i].ultraDespuesLub, 
        listRtes[i].vibraAntesLub, listRtes[i].vibraDespuesLub, listRtes[i].ultObservacion, 
        listRtes[i].observacionesReal, listRtes[i].numeroInflab, listRtes[i].mecInflab, 
        listRtes[i].fallaLub?listRtes[i].fallaLub:'N', listRtes[i].tiempoFalla?listRtes[i].tiempoFalla:0, listRtes[i].costoFalla?listRtes[i].costoFalla:0] 
// console.log(xlsString1)
        xlsString.push(xlsString1)
        descrEmpresa=listRtes[i].descrEmpresa
      }
// console.log(xlsString)

      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };

      wb.SheetNames.push("Ordenes");

      let ws_data = xlsString;

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Ordenes"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      console.log(this.state.argsDocum)
      if(campoAgno === 'DI'){
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'RUTA DIARIA'+this.state.argsDocum.ruta+'_'+descrEmpresa+'.xlsx');
      }else{
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'RUTA_'+this.state.argsDocum.ruta+'_'+descrEmpresa+'.xlsx');
      }
    }
    //FIN Exportar a XLS
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }
  
  handleCopiaInfPdf = async (ev, list)=>{
    if(list.length>0){

      document.body.style.cursor = 'wait'
      let list1 = list

      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      let widthDoc = (doc.internal.pageSize.width)
      let heightDoc = (doc.internal.pageSize.height)

      //MECANISMOS POR EQUIPO
        for(let ii=0; ii<list.length; ii++){
          doc.setFillColor('#E9E4F0');
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'F', true)
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'F', true)
          doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'F', true)
          doc.setFillColor('#bdc3c7');

          doc.setDrawColor('black');
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'S', true)
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'S', true)
          doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'S', true)

          doc.setFontSize(8);
          doc.setFontStyle('bold');
          doc.text(`PLANTA: ${list[ii].descrPlanta}`,14, 40)
          doc.text(`SECCION: ${list[ii].descrSeccion}`, (widthDoc/2)+2, 40)
          doc.text(`OPERARIO: ${list[ii].nombreUsuario}  -  EQUIPO: ${list[ii].codEquipo} ${list[ii].descrEquipo}`, (widthDoc/2), 45, 'center')

          const mecanismos1 = await list1.filter(elemento => elemento.descrPlanta===list[ii].descrPlanta&&
            elemento.descrSeccion===list[ii].descrSeccion)

          mecanismos1.forEach((elemento1, iii) => {
            mecanismos1[iii].indice = iii
          })

          let tablaRte = []
          let descrEquipo = ""
          mecanismos1.forEach((elemento1, iii) => {
            let argsUpd = []
            if(descrEquipo!==elemento1.descrEquipo && iii>0){
              descrEquipo = elemento1.descrEquipo
              argsUpd.push(`OPERARIO: ${list[ii].nombreUsuario}  -  EQUIPO: ${elemento1.codEquipo} ${elemento1.descrEquipo}`)
              tablaRte.push(argsUpd)
              argsUpd = []
            }else{
              descrEquipo = elemento1.descrEquipo
            }
            
            argsUpd.push(elemento1.numeroOrden)
            argsUpd.push(elemento1.fechaProg?elemento1.fechaProg.substr(0, 10):"")
            argsUpd.push("")
            argsUpd.push(elemento1.descrFrecuencia)
            argsUpd.push(elemento1.descrComponente)
            argsUpd.push(elemento1.descrMecanismo)
            argsUpd.push(elemento1.puntosLub)
            argsUpd.push(elemento1.descrMetodo)
            argsUpd.push(elemento1.descrTarea)
            argsUpd.push(elemento1.minutos)
            argsUpd.push("")
            argsUpd.push(elemento1.descrLubricante)
            argsUpd.push(elemento1.cantidad)
            argsUpd.push("")
            argsUpd.push(elemento1.abrevUnidad)
            argsUpd.push(elemento1.observacionesReal)
            tablaRte.push(argsUpd) 
          })
          let descrPlanta = list[ii].descrPlanta
          let descrSeccion = list[ii].descrSeccion

          for(let iii=0; iii<mecanismos1.length+1; iii++){
            if(list[ii].descrPlanta===descrPlanta&&list[ii].descrSeccion===descrSeccion){
                if(ii<list.length-1){
                  ii += 1
                  if(list[ii].numeroOrden===13072){console.log(ii, iii)}
                }
            }else{
              ii -= 1
              iii=mecanismos1.length+1
            }
          }
          let indice = 0
          let esComp = false
          doc.autoTable({
            startY: 46,
            rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
            showHead: 'everyPage',
            tableLineColor: "black",
            tableLineWidth: 0.1,
            styles: {
              fontSize: 6,
              lineColor: "black",
              lineWidth: 0.1,
              valign: "top",
            },
            headStyles: {
              fillColor: "#E9E4F0",
              textColor: "black",
              halign: "center",
              valign: "top",
              cellPadding: 1,
              fontStyle: "bold",
              fontSize: 6
            },
            bodyStyles: {
              // fillColor: "#E9E4F0",
              fillColor: "white",
              textColor: "black",
              halign: "center",
              minCellHeight: 3
            },
            columnStyles: {
              0: {cellWidth: 8},
              1: {cellWidth: 14},
              2: {cellWidth: 13},
              3: {cellWidth: 13},
              4: {cellWidth: 20},
              5: {cellWidth: 25},
              6: {cellWidth: 7},
              7: {cellWidth: 18},
              8: {cellWidth: 24},
              9: {cellWidth: 6},
              10: {cellWidth: 6},
              11: {cellWidth: 20},
              12: {cellWidth: 9},
              13: {cellWidth: 9},
              14: {cellWidth: 6},
              15: {cellWidth: 29},
              16: {cellWidth: 22.7},
            },

            didParseCell(data) {
              if(data.row.index !== -1 && data.section==='body'){
                if(data.column.index === 0){
                  esComp = false
                  if(data.cell.text[0].substr(0, 9)==='OPERARIO:'){
                    esComp = true
                  }
                }

                data.cell.styles.minCellHeight = 3
                data.cell.styles.fillColor = "white"
                data.cell.styles.fontStyle = "normal"
                if(esComp){
                  if(data.column.index===0){
                    data.cell.colSpan = 15
                    data.cell.styles.halign = "center"
                    data.cell.styles.fontStyle = "bold"
                  }
                  data.cell.styles.minCellHeight = 3
                  data.cell.styles.fillColor = "#E9E4F0"
                }
              }
            },

            didDrawCell: (data) => {
              //imagenes en autoTable
              //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
if(data.row.index===-1){
console.log("ojoooo")
}

              if(data.row.index !== -1 && data.section==='body' && data.column.index === 0){
                esComp = false
                if(data.row.index===0){
                  indice = 0
                }else{
                  if(data.cell.text[0].substr(0, 9)!=='OPERARIO:'){
                    indice += 1
                  }else{
                    esComp = true
                  }
                }
              }
            },
            alternateRowStyles: {
              // fillColor: "white",
              textColor: "black"
            },
            head: [["Act.", "Fecha prog", "Fecha real", "Frecuencia", "Componente", "Mecanismo", "Ptos", "Método", "Tarea", "Min", "Min real", "Lubricante", "Cant", "Cant real", "Und", "observaciones", "Firmas"]],
            body: tablaRte,
            margin: {top: 40, left: 12, right: 12, bottom: 25}
          })
          if(ii<list.length-1){
            doc.addPage()
          }
        }
        //FIN MECANISMOS POR EQUIPO

        const pageCount = doc.internal.getNumberOfPages();
        // For each page, print the page number and the total pages
        for(var i = 1; i <= pageCount; i++) {
              // Go to page i
            doc.setPage(i);

//ENCABEZADO DE PAGINA
            doc.setFontSize(12);
            doc.setFontType("bold");
            doc.text(list1[0].descrEmpresa, widthDoc/2, 14, 'center')
            doc.text("RUTA DE LUBRICACION No. " + String(list1[0].ruta), widthDoc/2, 20, 'center')
            doc.setFontSize(8);

            let dirSlcm = 'images/logos/LCMSAS.png'
            let logo = ""
            if(this.props.allEmpresaRtes.allEmpresaRtes){

              let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${list1[0].descrEmpresa}'}}]`}
              console.log(argsBuscarEmp)
              let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
              console.log(data.allEmpresaRtes)
              logo = await data.allEmpresaRtes[0].logo
              console.log(logo)
            }
            let dirEmpresa = 'images/logos/' + logo
            let imgSource = new Image();
            try{
              imgSource.src = dirSlcm;
              doc.convertStringToImageData(imgSource)
              doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
            }catch{
              console.log("Logo de LCM no existe")
            }

            try{
              imgSource.src = dirEmpresa;
              doc.convertStringToImageData(imgSource)
              doc.addImage(imgSource, 'PNG', widthDoc-55-12, 12, 55, 17);
            }catch{
              console.log("Logo de la empresa no existe")
            }
//FIN ENCABEZADO DE PAGINA

            doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
            doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
            // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
        }
      let nameDoc = `RUTA_${list1[0].ruta}_${list1[0].descrEmpresa}.pdf`
      doc.save(nameDoc)

      document.body.style.cursor = 'default'
    }
    
    //FIN Exportar a Pdf
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }

  handleCopiaInfPdfqr = async (ev, list)=>{
    var QRCode = require('qrcode');

    if(list.length>0){
      document.body.style.cursor = 'wait'
      let list1 = list

      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      let widthDoc = (doc.internal.pageSize.width)
      let heightDoc = (doc.internal.pageSize.height)

      //MECANISMOS POR EQUIPO
        for(let ii=0; ii<list.length; ii++){
          doc.setFillColor('#E9E4F0');
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'F', true)
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'F', true)
          doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'F', true)
          doc.setFillColor('#bdc3c7');

          doc.setDrawColor('black');
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'S', true)
          doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'S', true)
          doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'S', true)

          doc.setFontSize(8);
          doc.setFontStyle('bold');
          doc.text(`PLANTA: ${list[ii].descrPlanta}`,14, 40)
          doc.text(`SECCION: ${list[ii].descrSeccion}`, (widthDoc/2)+2, 40)
          doc.text(`OPERARIO: ${list[ii].nombreUsuario}  -  EQUIPO: ${list[ii].codEquipo} ${list[ii].descrEquipo}`, (widthDoc/2), 45, 'center')

          const mecanismos1 = await list1.filter(elemento => elemento.descrPlanta===list[ii].descrPlanta&&
            elemento.descrSeccion===list[ii].descrSeccion)

          mecanismos1.forEach((elemento1, iii) => {
            mecanismos1[iii].indice = iii
          })

          let tablaRte = []
          let descrEquipo = ""
          mecanismos1.forEach((elemento1, iii) => {
            let argsUpd = []
            if(descrEquipo!==elemento1.descrEquipo && iii>0){
              descrEquipo = elemento1.descrEquipo
              argsUpd.push(`OPERARIO: ${list[ii].nombreUsuario}  -  EQUIPO: ${elemento1.codEquipo} ${elemento1.descrEquipo}`)
              tablaRte.push(argsUpd)
              argsUpd = []
            }else{
              descrEquipo = elemento1.descrEquipo
            }
            
            argsUpd.push(elemento1.numeroOrden)
            argsUpd.push(elemento1.fechaProg?elemento1.fechaProg.substr(0, 10):"")
            argsUpd.push(elemento1.descrComponente)
            argsUpd.push(elemento1.descrMecanismo)
            argsUpd.push(elemento1.descrTarea)
            argsUpd.push("")
            tablaRte.push(argsUpd) 
          })
          let descrPlanta = list[ii].descrPlanta
          let descrSeccion = list[ii].descrSeccion

          for(let iii=0; iii<mecanismos1.length+1; iii++){
            if(list[ii].descrPlanta===descrPlanta&&list[ii].descrSeccion===descrSeccion){
                if(ii<list.length-1){
                  ii += 1
                }
            }else{
              ii -= 1
              iii=mecanismos1.length+1
            }
          }
          let indice = 0
          let esComp = false
          doc.autoTable({
            startY: 46,
            rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
            showHead: 'everyPage',
            tableLineColor: "black",
            tableLineWidth: 0.1,
            styles: {
              fontSize: 6,
              lineColor: "black",
              lineWidth: 0.1,
              valign: "top",
            },
            headStyles: {
              fillColor: "#E9E4F0",
              textColor: "black",
              halign: "center",
              valign: "top",
              cellPadding: 1,
              fontStyle: "bold",
              fontSize: 6
            },
            bodyStyles: {
              // fillColor: "#E9E4F0",
              fillColor: "white",
              textColor: "black",
              halign: "center",
              valign: "center",
              minCellHeight: 15
            },
            columnStyles: {
              0: {cellWidth: 15},
              1: {cellWidth: 21.7},
              2: {cellWidth: 45},
              3: {cellWidth: 45},
              4: {cellWidth: 45},
              5: {cellWidth: 18},
            },

            didParseCell(data) {
              if(data.row.index !== -1 && data.section==='body'){
                if(data.column.index === 0){
                  esComp = false
                  if(data.cell.text[0].substr(0, 9)==='OPERARIO:'){
                    esComp = true
                  }
                }

                // data.cell.styles.minCellHeight = 3
                // data.cell.styles.fillColor = "white"
                // data.cell.styles.fontStyle = "normal"
                // if(esComp){
                //   if(data.column.index===0){
                //     data.cell.colSpan = 15
                //     data.cell.styles.halign = "center"
                //     data.cell.styles.fontStyle = "bold"
                //   }
                //   data.cell.styles.minCellHeight = 3
                //   data.cell.styles.fillColor = "#E9E4F0"
                // }
              }
            },

            didDrawCell: (data) => {
              //imagenes en autoTable
              //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
if(data.row.index===-1){
console.log("ojoooo")
}

              if(data.row.index !== -1 && data.section==='body' && data.column.index === 0){
                esComp = false
                if(data.row.index===0){
                  indice = 0
                }else{
                  if(data.cell.text[0].substr(0, 9)!=='OPERARIO:'){
                    indice += 1
                  }else{
                    esComp = true
                  }
                }
              }

              if(data.row.index !== -1 && data.section==='body' && data.column.index === 5 && !esComp){
                if(mecanismos1[indice].codigoQR){
                  let canvas = document.createElement("canvas");
                  QRCode.toCanvas(canvas, mecanismos1[indice].codigoQR)
                  let imgSourceQR = canvas.toDataURL("image/svg");
                  doc.addImage(imgSourceQR, 'svg', data.cell.x + 3, data.cell.y + 2, 12, 12);
                }
              }
            },
            alternateRowStyles: {
              // fillColor: "white",
              textColor: "black"
            },
            head: [["Orden", "Fecha prog", "Componente", "Mecanismo", "Tarea", "QR Mecanismo"]],
            body: tablaRte,
            margin: {top: 40, left: 12, right: 12, bottom: 25}
          })
          if(ii<list.length-1){
            doc.addPage()
          }
        }
        //FIN MECANISMOS POR EQUIPO

        const pageCount = doc.internal.getNumberOfPages();
        // For each page, print the page number and the total pages
        for(var i = 1; i <= pageCount; i++) {
              // Go to page i
            doc.setPage(i);

//ENCABEZADO DE PAGINA
            doc.setFontSize(12);
            doc.setFontType("bold");
            doc.text(list1[0].descrEmpresa, widthDoc/2, 14, 'center')
            doc.text("RUTA DE LUBRICACION No. " + String(list1[0].ruta), widthDoc/2, 20, 'center')
            doc.setFontSize(8);

            let dirSlcm = 'images/logos/LCMSAS.png'
            let logo = ""
            if(this.props.allEmpresaRtes.allEmpresaRtes){

              let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${list1[0].descrEmpresa}'}}]`}
              console.log(argsBuscarEmp)
              let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
              console.log(data.allEmpresaRtes)
              logo = await data.allEmpresaRtes[0].logo
              console.log(logo)
            }
            let dirEmpresa = 'images/logos/' + logo
            let imgSource = new Image();
            try{
              imgSource.src = dirSlcm;
              doc.convertStringToImageData(imgSource)
              doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
            }catch{
              console.log("Logo de LCM no existe")
            }

            try{
              imgSource.src = dirEmpresa;
              doc.convertStringToImageData(imgSource)
              doc.addImage(imgSource, 'PNG', widthDoc-55-12, 12, 45, 17);
            }catch{
              console.log("Logo de la empresa no existe")
            }
//FIN ENCABEZADO DE PAGINA

            doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
            doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
            // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
        }
      let nameDoc = `RUTA_${list1[0].ruta}_${list1[0].descrEmpresa}.pdf`
      doc.save(nameDoc)

      document.body.style.cursor = 'default'
    }
    
    //FIN Exportar a Pdf
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }


  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  // componentDidMount(){
  //   if(this.props.allOrdenRtes.allOrdenRtes){
  //     if(this.props.allOrdenRtes.allOrdenRtes.length>0&&this.state.argsDocum.ruta===0){
  //       let argsBuscar=""
  //       argsBuscar += `'ruta': ${this.props.allOrdenRtes.allOrdenRtes[0].ruta}`
  //       let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
  //       this.props.allOrdenRtes2.refetch(argsBuscarIl)
  //       const argsDocum = this.state.argsDocum
  //       argsDocum.ruta = this.props.allOrdenRtes.allOrdenRtes[0].ruta
  //       this.setState({argsDocum})
  //     }
  //   }
  // }

  async componentDidUpdate(prevProps){
    if(this.props.argsBuscProg!==this.state.argsBuscProg){
      let argsBuscar=""
      let list = []
      let ver=this.state.argsDocum.miLista1
      if(ver==='Todo'){
        argsBuscar += `'estadoOrden': 'Abierto', 'descrEmpresa': '${this.state.argsDocum.descrEmpresa}', 'ruta': ${this.state.argsDocum.ruta}`
      }else{
        if(ver==='Pendiente'){
          argsBuscar += `'alimSistema': 'N', 'estadoOrden': 'Abierto', 'descrEmpresa': '${this.state.argsDocum.descrEmpresa}', 'ruta': ${this.state.argsDocum.ruta}`
        }else{
          if(ver==='Reportado'){
            argsBuscar += `'alimSistema': 'S', 'estadoOrden': 'Abierto', 'descrEmpresa': '${this.state.argsDocum.descrEmpresa}', 'ruta': ${this.state.argsDocum.ruta}`
          }else{
            if(ver==='No ejecutado'){
              argsBuscar += `'alimSistema': 'S', 'realizado': 'N', 'estadoOrden': 'Abierto', 'descrEmpresa': '${this.state.argsDocum.descrEmpresa}', 'ruta': ${this.state.argsDocum.ruta}`
            }
          }
        }
      }
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }

      let argsBuscarOrden = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {fechaProg: 1}}]`}
      // let {data} = await this.props.allOrdenRtes2.refetch(argsBuscarOrden)
      await this.props.allOrdenRtes2.refetch(argsBuscarOrden)
      if(this.props.allOrdenRtes2.allOrdenRtes){
        this.setState({argsBuscProg: this.props.argsBuscProg})
        if(this.props.allOrdenRtes2.allOrdenRtes&&prevProps.allOrdenRtes2.allOrdenRtes){
          console.log(this.props.allOrdenRtes2.allOrdenRtes)
          if((this.props.allOrdenRtes2.allOrdenRtes!==prevProps.allOrdenRtes2.allOrdenRtes)||!this.state.list){
            // console.log(this.state.list)
            this.setState({list: this.props.allOrdenRtes2.allOrdenRtes})
            console.log(this.state.list)
          }
        }
        this.setState({argsBuscProg: this.props.argsBuscProg})
      }



      // if(this.props.allOrdenRtes2.allOrdenRtes){
      //   list = this.props.allOrdenRtes2.allOrdenRtes
      //   console.log(list)
      // }
      // this.setState({list});
    }
  }

  render(){
    // console.log(this.state.list)
    const {listDocum, checked, permiteBtn1, permiteBtn2, confirmaAct, open, errors, procBtn, argsDocum, listNum, list, idLista, handleLista} = this.state;
      let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let mensaje1 = "CARGAR"
    let imgIcon1 = "images/documento_32.png"
    let mensaje2 = "CERRAR RUTA"
    let imgIcon2 = "images/archivo_32.png"
    const a1505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "1505" );

    let descrEmpresaUA=localStorage.getItem('Empresa')
console.log(idLista)
    let list2 = [], list3 = []
    list3.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
// console.log(argsDocum)

    list2.push({ruta: "Seleccionar ruta...", _id: 0})
// console.log(argsDocum)

    if(descrEmpresaUA==="Todas..."){
console.log(this.props.allOrdenRtes3.allOrdenRtes)
      if(this.props.allOrdenRtes3.allOrdenRtes){
        this.props.allOrdenRtes3.allOrdenRtes.forEach((elemento, ii) => {
          list3.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
        })
      }
    }else{
// console.log(this.props.allOrdenRtes3.allOrdenRtes)
      if(this.props.allOrdenRtes3.allOrdenRtes){
        this.props.allOrdenRtes3.allOrdenRtes.forEach((elemento, ii) => {
          if(descrEmpresaUA===elemento.descrEmpresa){
            list3.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
          }
        })
      }
    }
  
    if (argsDocum.descrEmpresa!=="Seleccionar Empresa..."){
      listNum.forEach((elemento, ii) => {
        list2.push({ruta: elemento.ruta, _id: ii+1})
      })
    }
  
// console.log(listDocum)
    return (
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <TitDer list={list} textBoton1="Rutas programadas y abiertas" btnNuevo={"NO"} styles={this.props.styles}  />
          <Form name="form1" id="form1" onSubmit={confirmaAct
            ?permiteBtn1
              ?(ev)=>this.handleSubmit(ev, listDocum, list)
              :
              permiteBtn2
                ?(ev)=>this.handleCerrar(ev, list)
                :()=>{}                
            :()=>{}}
          > 
            <div className="ui nine column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '12%', paddingLeft: '0.5em'}}>
                  <Form.Field>
                  <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal'}}>Empresa</label>
                    <ListaEmp styles={this.props.styles} list={list3} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '10%', paddingLeft: '0.5em'}}>
                  <Form.Field>
                  <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal'}}>Ruta</label>
                    <ListaNuminf styles={this.props.styles} list={list2} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '10%', paddingLeft: '0.5em'}}>
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal'}}>Ver</label>
                    <ListaVer styles={this.props.styles} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '18%', paddingRight: '0.1em'}}>
                  <Form.Field>
                    <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                      <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                              name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                      &nbsp;&nbsp;Encabezados en primera fila
                    </p>                 

                     <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>
                  </Form.Field>
                </div>
                {(permiteBtn1) &&
                  <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                    <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                  </div>   
                }
                <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                  <Button id="excel" name="excel" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCopiaInf(ev, list)} fluid>
                    RUTA EN EXCEL
                  </Button>
                </div>
                <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                  <Button id="pdf" name="pdf" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCopiaInfPdf(ev, list)} fluid>
                    RUTA EN PDF
                  </Button>
                </div>
                <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                  <Button id="pdfqr" name="pdfqr" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCopiaInfPdfqr(ev, list)} fluid>
                    RUTA CON QR
                  </Button>
                </div>
                {(permiteBtn2) &&
                  <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                    <EstaSeg7Btn mensaje2={mensaje2} imgIcon2={imgIcon2} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>
                  </div>
                }
              </div>
            </div>
            <hr></hr>
            <div>
              <div style={{height: '56em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Fecha prog.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Fecha ejec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Empresa</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Operario ejec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Metodo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Tarea</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Frecuencia</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Ult. ejec</th>
                    </tr>
                  </thead>
                  <ListaPl list={list} handleClickidLista={a1505!==-1?this.props.handleClickidLista:()=>{}}/>
                </table>
                <p></p>
              </div>
            </div>
            <hr></hr>
            <div>
              <div style={{height: '28em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    {/* <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>tipo frec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Realizado?</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Rep. lab.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inf. lab.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Hora real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Min. real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant. real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Und.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Acum. (horas/km)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Observaciones</th>                    
                    </tr>  */}
                  </thead>
                  {/* <ListaPlDet list={list} handleClickidLista={this.handleClickidLista} idLista={idLista}/> */}
                </table>
                <p></p>
              </div>
            </div>
            <hr></hr>
            
            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    <img src={idLista.imgAntes?'https://montserratslcm.com/api/imgorden/' + idLista.imgAntes:""} width='70%'></img>
                  </div>
                </div>
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    <img src={idLista.imgDespues?'https://montserratslcm.com/api/imgorden/' + idLista.imgDespues:""} width='70%'></img>
                  </div>
                </div>
              </div>
            </div>

            {
              errors.length?<Message negative header="Los siguientes errores:"
              list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

          </Form>
        </div>
    )
  }
};

export default compose(
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'ruta': -1}}]`}}}}),

  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoOrden': 'Abierto'}},
      {$group: {_id: {ruta: '$ruta', descrEmpresa: '$descrEmpresa'}}}, 
      {$project: {_id: 0, ruta: '$_id.ruta', descrEmpresa: '$_id.descrEmpresa'}},
      {$sort: {ruta: -1}}]`}}}}),

  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes3',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoOrden': 'Abierto'}},
      {$group: {_id: '$descrEmpresa'}}, {$sort: {_id: 1}}, {$project: {'descrEmpresa': '$_id'}}]`}}}}),

  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allLubricante, {name:'allLubricante'}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),

  graphql(queries.mutation.editOrden, {name:'editOrden'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProgRepProg2)
